import { Locale } from '@klokhuis/core/Intl/types';
import * as Sentry from '@sentry/nextjs';
import { CaptureContext } from '@sentry/types';

export function setUserContextForErrorReporting(
  user: Pick<any, 'useremail'>,
  locale: Locale,
  anonymousId: string | null,
) {
  Sentry.setUser({
    email: user.useremail?.toString(),
    locale,
    anonymousId,
  });
}
export function setCustomErrorTag(tagName: string, value: string) {
  Sentry.setTag(tagName, value);
}

export function reportError(error: Error, captureContext?: CaptureContext) {
  if (!error) return;
  const { message, stack, ...rest } = error;
  const sentryEventId = Sentry.captureException(error, captureContext);
  console.log('sentry event id', sentryEventId);

  // fixme: re-enable logging when Sentry is working again
  // logger.error({
  //   message,
  //   stack,
  //   sentryEventId,
  //   associatedEvent: `https://sentry.io/Klokhuis/klokhuis-nextjs/events/${sentryEventId}`,
  //   context: captureContext,
  //   ...rest,
  // });
}
